"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var styles = tslib_1.__importStar(require("./Chip.style"));

var ChipItem_1 = tslib_1.__importDefault(require("./ChipItem"));

var Chip = react_1.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      items = _ref.items,
      defaultActiveChipId = _ref.defaultActiveChipId,
      onChange = _ref.onChange,
      onActiveListChange = _ref.onActiveListChange,
      _ref$shape = _ref.shape,
      shape = _ref$shape === void 0 ? 'filled' : _ref$shape,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'vertical' : _ref$direction;

  var _react_1$useState = react_1.useState(defaultActiveChipId || items.length > 0 ? items[0].id : ''),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      activeChipId = _react_1$useState2[0],
      setActiveChipId = _react_1$useState2[1];

  var defaultInlineActiveList = react_1.useMemo(function () {
    return items.reduce(function (acc, cur) {
      acc[cur.id] = Boolean(cur.active);
      return acc;
    }, {});
  }, [items]);

  var _react_1$useState3 = react_1.useState(defaultInlineActiveList),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      inlineActiveList = _react_1$useState4[0],
      setInlineActiveList = _react_1$useState4[1];

  var getChipActive = react_1.useCallback(function (id, active) {
    if (active) {
      return Boolean(active);
    }

    if (direction === 'inline') {
      return Boolean(inlineActiveList[id]);
    }

    return activeChipId === id;
  }, [activeChipId, direction, inlineActiveList]);
  var handleOnClick = react_1.useCallback(function (id, draftActiveChip) {
    setActiveChipId(draftActiveChip.id);

    if (direction === 'inline') {
      inlineActiveList[draftActiveChip.id] = !inlineActiveList[draftActiveChip.id];
      setInlineActiveList(inlineActiveList);
      onActiveListChange && onActiveListChange(inlineActiveList);
    }

    onChange && onChange(Object.assign(Object.assign({}, draftActiveChip), {
      active: direction === 'inline' ? Boolean(inlineActiveList[draftActiveChip.id]) : draftActiveChip.id === id
    }));
  }, [direction, inlineActiveList, onActiveListChange, onChange]);
  react_1.useEffect(function () {
    if (defaultActiveChipId) {
      setActiveChipId(defaultActiveChipId);
    }
  }, [defaultActiveChipId]);
  return jsx_runtime_1.jsx("div", Object.assign({
    ref: ref,
    className: className,
    css: styles.container(direction)
  }, {
    children: items.map(function (_ref2, index) {
      var content = _ref2.content,
          icon = _ref2.icon,
          activeIcon = _ref2.activeIcon,
          id = _ref2.id,
          active = _ref2.active;
      return jsx_runtime_1.jsx(ChipItem_1.default, Object.assign({
        id: id,
        className: "mrt-chip-item",
        index: index,
        shape: shape,
        active: getChipActive(id, active),
        icon: icon,
        activeIcon: activeIcon,
        onClick: handleOnClick
      }, {
        children: content
      }), id);
    })
  }), void 0);
});
exports.default = Chip;